var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9457_3062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.962 18 18 13.962 18 9C18 4.03801 13.962 0 9 0C4.03796 0 0 4.03801 0 9C0 13.962 4.03801 18 9 18ZM9 1.19998C13.302 1.19998 16.8 4.69797 16.8 9C16.8 13.302 13.302 16.8 9 16.8C4.69797 16.8 1.19998 13.302 1.19998 9C1.19998 4.69797 4.69802 1.19998 9 1.19998Z",
    fill: "#1E2228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6249 11.8676C11.7359 11.9576 11.8679 11.9996 11.9999 11.9996C12.1769 11.9996 12.3509 11.9216 12.4679 11.7746C12.6749 11.5166 12.6328 11.1386 12.3749 10.9316L9.59988 8.7116V4.1996C9.59988 3.86959 9.3299 3.59961 8.99989 3.59961C8.66989 3.59961 8.3999 3.86959 8.3999 4.1996V8.99962C8.3999 9.18263 8.48392 9.35362 8.6249 9.4676L11.6249 11.8676Z",
    fill: "#1E2228"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9457_3062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClocks);
export default __webpack_public_path__ + "static/media/clocks.1bace47372aac65114ba8a33849b16cc.svg";
export { ForwardRef as ReactComponent };